import EmailsFormContainer from './EmailsFormContainer';

export default EmailsFormContainer;
